import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { withRouter } from "../providers/withRouter";
import Delete from "../icons/delete.svg";
import Editar from "../icons/editar.svg";
import { BsPinAngle, BsPinFill } from "react-icons/bs";
import { IoMail, IoCall, IoLogoWhatsapp } from "react-icons/io5";
import { formatoFechasEs } from '../functions/funciones';

const CONTACTO_META_LEGACY = {
  mail: { icon: IoMail, label: 'Mail' },
  llamada: { icon: IoCall, label: 'Llamada' },
  whatsapp: { icon: IoLogoWhatsapp, label: 'Whatsapp' },
};

const CONTACTO_LABELS = {
  solicitud_docs: { key: 'comments.contactTypes.solicitudDocs', fallback: 'Solicitud de documentación' },
  seguimiento: { key: 'comments.contactTypes.seguimiento', fallback: 'Llamada y/o correo de seguimiento' },
  explicacion_docs: { key: 'comments.contactTypes.explicacionDocs', fallback: 'Explicación de la documentación requerida y cómo obtenerla' },
  subida_actualizacion: { key: 'comments.contactTypes.subidaActualizacion', fallback: 'Subida o actualización de documentación' },
  incidencias_plataforma: { key: 'comments.contactTypes.incidenciasPlataforma', fallback: 'Resolución de incidencias o dudas sobre la plataforma' },
  verificacion_datos: { key: 'comments.contactTypes.verificacionDatos', fallback: 'Verificación de los datos del proveedor' },
};

const ComentariosEstructura = (props) => {
  const { t } = useTranslation('common');
  const comm = props.comm

  const [fijado, setFijado] = useState(!!comm.fijado);

  // Sincronizar el estado local cuando cambia la prop
  useEffect(() => {
    setFijado(!!comm.fijado);
  }, [comm.fijado, comm.id]);

  const eliminar = (id) => {
      props.eliminarComment(id)
  }
  const editar = (id, comentario) => {
      props.editarComment(id, comentario)
  }

  const fijar = (id) => {
    props.fijarComment(id, !fijado)
    setFijado(!fijado)
  }

  return (
    <div className="comment-card">
      <div className="comment-header">
        <div className="user-info">
            {/* <div class="avatar">MM</div> */}
            <div class="user-details">
                <h3>{comm.usuario?.nombre + " " + comm.usuario?.apellidos}</h3>
            </div>
        </div>
        <div>
          <span className="date-badge">{formatoFechasEs(comm.createdAt)}</span>
          {!props.readOnly && (
            <>
              <span>
                {fijado ?
                  <BsPinFill style={{fontSize:18}} onClick={() => fijar(comm.id)} />
                :
                  <BsPinAngle style={{fontSize:18}} onClick={() => fijar(comm.id)} />
                }
              </span>
              <img
                src={Editar}
                alt={t('actions.edit')}
                className="tableIcon"
                onClick={() => editar(comm.id, comm)}
                style={{ width: 14 }}
              ></img>
              <img
                src={Delete}
                alt={t('actions.delete')}
                className="tableIcon"
                onClick={() => eliminar(comm.id)}
                style={{ width: 14, margin:0 }}
              ></img>
            </>
          )}
        </div>
      </div>
      {comm.texto && (
        <div class="comment-body" style={{ whiteSpace: 'pre-wrap' }}>
            {comm.texto}
        </div>
      )}
      {(comm.tipo_contacto || comm.ambito) && (
        <div style={{ display: 'flex', gap: 8, marginTop: 6, flexWrap: 'wrap' }}>
          {(comm.tipo_contacto || '')
            .split(',')
            .map((tc) => tc.trim())
            .filter(Boolean)
            .map((tc) => {
              if (CONTACTO_LABELS[tc]) {
                return (
                  <span key={tc} style={{ display: 'inline-flex', alignItems: 'center', fontSize: 11, background: '#f3e6ee', color: '#92004D', borderRadius: 12, padding: '2px 8px' }}>
                    {t(CONTACTO_LABELS[tc].key, { defaultValue: CONTACTO_LABELS[tc].fallback })}
                  </span>
                );
              }
              if (CONTACTO_META_LEGACY[tc]) {
                return (
                  <span key={tc} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, background: '#f3e6ee', color: '#92004D', borderRadius: 12, padding: '2px 8px' }}>
                    {React.createElement(CONTACTO_META_LEGACY[tc].icon, { style: { fontSize: 13 } })}
                    {CONTACTO_META_LEGACY[tc].label}
                  </span>
                );
              }
              return null;
            })}
          {comm.ambito && (
            <span style={{ display: 'inline-flex', alignItems: 'center', fontSize: 11, background: '#eef0f2', color: '#555', borderRadius: 12, padding: '2px 8px', textTransform: 'capitalize' }}>
              {comm.ambito}
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default withRouter(ComentariosEstructura);